import tw, { styled } from 'twin.macro';

import { motion } from '@sopranodesign/framer-motion';

const FormGroup = styled(motion.div)`
  & > *:not(:last-child) {
    ${tw`mb-4`}
  }
`;

export default FormGroup;
